import { render } from "./BaseMainNavMenu.vue?vue&type=template&id=73696b4e"
import script from "./BaseMainNavMenu.vue?vue&type=script&lang=js"
export * from "./BaseMainNavMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__